module.exports = __webpack_public_path__ + "static/media/roomsD.2e7fa1d2.png";